import { Injectable } from '@angular/core';

import { SnCurrentUser } from '@lib/auth/services';

import { SnLayoutNavbarContainer } from '../containers';
import { SnLayoutAppbarReference } from '../references';
import { SnLayoutStorageService } from './layout-storage.service';

@Injectable()
export class SnLayoutService {
  public pushTitle: boolean = false;
  // respect the lockToolbar setting if it exists – if it's null default to false for video wall users, and true otherwise
  public lockAppbar: boolean =
    this._currentUser.settings?.mapSetting?.lockToolbar ?? !this._currentUser.isVideoWallUser;
  public isOnMap: boolean;
  public isOnSentryViewContainer: boolean = false;
  public alarmBoundary: boolean;

  constructor(
    private readonly _layoutStorage: SnLayoutStorageService,
    private readonly _currentUser: SnCurrentUser,
  ) {}

  get appbar(): SnLayoutAppbarReference {
    return this._layoutStorage.appbarRef;
  }

  get appbarIsAvalible(): boolean {
    return !!this.appbar;
  }

  get navbar(): SnLayoutNavbarContainer {
    return this._layoutStorage.navbarRef;
  }

  get navbarIsAvalible(): boolean {
    return !!this.navbar;
  }

  get alarmBoundaryClicked(): boolean {
    return !!this.alarmBoundary;
  }
}
